import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import ModalLoader from 'components/modals/ModalLoader';

export default class ModalContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        title: PropTypes.node,
        footer: PropTypes.node,
        className: PropTypes.string,
        refresh: PropTypes.func,
        meta: PropTypes.object,
        modal: PropTypes.object.isRequired
    };

    render() {
        const { className, modal, refresh, meta = {}, children, footer = null, title } = this.props;

        return (
            <Modal {...modal} className={className} title={title} footer={footer}>
                <ModalLoader refresh={refresh} meta={meta}>
                    { children }
                </ModalLoader>
            </Modal>
        );
    }
}
